module.exports = __webpack_public_path__ + "static/UNITY-Square-Two-1st-floor-modern_v2-7bbc13ddf7c62d93a508d1c29f10b425.pdf";